export default "__VITE_ASSET__1b63bda8__"